import {HostDTO} from '@domain/host/host.dto';
import {ActivityScheduleDTO, ActivityScheduleLevel} from '@domain/activity/schedule/schedule.dto';
import {DayTime, PersonGender, WeekDay} from '@domain/common/common';
import {PlaceDTO} from '@domain/place/place.dto';
import {MediaDTO} from '@domain/media/media.dto';
import {CreateVenueRequest} from '@domain/venue/venue.dto';
import {ActivityTagDTO} from '@domain/activity-tag/activity-tag.dto';

export interface ActivityDTO extends
  ActivityAbout,
  ActivitySchedule,
  ActivityPrice,
  ActivityLinks {
  id: string;
  state: ActivityState;
  cover?: MediaDTO | null;
  mainHost?: HostDTO;
  canBeSubmitted?: boolean;
  isValid?: boolean;
  lastExpireReminder?: string;
  inserted?: string;
  lastUpdated?: string;
  lastUpdates?: string[] | null;
  verified?: boolean;
}

export interface UpdateActivityRequest extends
  ActivityAbout,
  ActivitySchedule,
  ActivityPrice,
  ActivityLinks {
}

export interface ActivityAbout {
  // id: string;
  type?: ActivityType;
  title?: string | null;
  description?: string | null;
  activities?: string[];
  tags?: ActivityTagDTO[] | null;
}

export interface ActivitySchedule {
  schedules?: ActivityScheduleDTO[];
}

export interface ActivityLinks {
  webUrl?: string | null;
  fbUrl?: string | null;
  igUrl?: string | null;
}

export interface ActivityPrice {
  isFree?: boolean | null;
  isPricePerSession?: boolean | null;
  price?: number | null;
  maxPrice?: number | null;
  hasTrialOffers?: boolean | null;
  hasDiscountOffers?: boolean | null;
  priceDescription?: string | null;
}

export enum ActivityType {
  Activity = 'Activity',
  Event = 'Event'
}

export enum ActivityState {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Published = 'Published',
  Deleting = 'Deleting',
  Archived = 'Archived'
}

export interface ActivitySearchQuery {
  townCode: string;
  daysOfWeek?: WeekDay[];
  dayTimes?: DayTime[];
  level?: ActivityScheduleLevel[];
  gender?: PersonGender[];
  activityType?: ActivityType[];
  ageMin?: number;
  ageMax?: number;
  recurring?: boolean;
}

export interface ActivitySearchResponse {
  search: ActivitySearchQuery;
  town: PlaceDTO | null;
  total: number;
  results: ActivityDTO[];
}

export interface ActivitySearchCountResponse {
  count: number | null;
}

export interface SubmitActivityFeedbackRequest {
  rating: number | null;
  allowDisplay: boolean | null;
  liked: string | null;
  improve: string | null;
}

export interface RegisterActivityRequest {
  activity: CreateActivityRequest;
  publish: boolean;
}

export interface CreateActivityRequest {
  title: string;
  schedules: RegisterScheduleRequest[];
}

export interface RegisterScheduleRequest {
  venue: CreateVenueRequest;
}
